import { combineReducers } from "@reduxjs/toolkit";
import monthlyReportSlice from "./monthlyReportSlice";

const monthlyReportReducer = combineReducers({
  monthlyReport: monthlyReportSlice,
});

export default monthlyReportReducer;